import Handlebars from "handlebars/dist/handlebars.js";

var searchasssociationform = (function () {
    "use strict";

    if ($('.searchassociationform').length > 0) {

        $('body').on('click', '.searchassociationform #search', searchAssociationHandler);

        $('body').on('keyup', '#association', function (e) {
            if (e.keyCode === 13) {
                e.preventDefault();
                $(this).next().trigger('click');
                return false;
            }
        });
    }

    function searchAssociationHandler(e) {
        e.preventDefault();
        $('.searchassociationform .results').empty().append($("<img src='/static/media/ajax-loader2.gif' style='width:128px;height:15px;'/>"));
        var $this = $(this),
            searchValue = $('.searchassociationform #association').val(),
            source = $('#' + $this.data('template')).html(),
            template = Handlebars.compile(source),
            data = {
                "searchValue": searchValue
            };

        var ajaxRequest = $.ajax({
            url: SETTINGS.services.site.methods.searchAssociation,
            data: JSON.stringify(data)
        });

        ajaxRequest.done(doneHandler);
        ajaxRequest.fail(failHandler);

        function doneHandler(response) {

            if (response.Success) {
                var html = template(response.Data);
                $('.searchassociationform .results').empty().append(html);
            }
            else {
                $('.searchassociationform .results').empty().append($("<p>Ett fel uppstod</p>"));
            }
        }

        function failHandler(err) {
            $('.searchassociationform .results').empty().append($("<p>Ett fel uppstod</p>"));
        }
    }

})();